import DrawPanel from "../components/DrawPanel";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { Trophy, Swords, Users, Shield, Flame, Sparkles, ArrowLeft } from "lucide-react";
import HeroCarousel from "../components/HeroCarousel";
import ClanLogo from "../components/clan/ClanLogo";

function StatCard({ icon: Icon, label, value, testid, accent = "default" }) {
  const styles = {
    live: {
      card: "bg-gradient-to-br from-red-500/10 via-black/40 to-black/60 border border-red-500/30 shadow-[0_0_15px_rgba(239,68,68,0.1)]",
      icon: "h-11 w-11 rounded-xl bg-red-500/20 text-red-400 border border-red-500/40 shadow-[0_0_12px_rgba(239,68,68,0.3)] grid place-items-center shrink-0",
    },
    clans: {
      card: "bg-gradient-to-br from-indigo-500/10 via-black/40 to-black/60 border border-indigo-500/30 shadow-[0_0_15px_rgba(99,102,241,0.1)]",
      icon: "h-11 w-11 rounded-xl bg-indigo-500/20 text-indigo-300 border border-indigo-500/30 shadow-[0_0_12px_rgba(99,102,241,0.3)] grid place-items-center shrink-0",
    },
    players: {
      card: "bg-gradient-to-br from-purple-500/10 via-black/40 to-black/60 border border-purple-500/20 shadow-[0_0_15px_rgba(168,85,247,0.05)]",
      icon: "h-11 w-11 rounded-xl bg-purple-500/15 text-purple-300 border border-purple-500/30 shadow-[0_0_12px_rgba(168,85,247,0.2)] grid place-items-center shrink-0",
    },
    season: {
      card: "bg-gradient-to-br from-emerald-500/10 via-black/40 to-black/60 border border-emerald-500/20 shadow-[0_0_15px_rgba(16,185,129,0.05)]",
      icon: "h-11 w-11 rounded-xl bg-emerald-500/15 text-emerald-400 border border-emerald-500/30 shadow-[0_0_12px_rgba(16,185,129,0.2)] grid place-items-center shrink-0",
    },
    default: {
      card: "bg-[#111113]/90 border border-white/10",
      icon: "h-11 w-11 rounded-xl bg-white/5 text-white/70 border border-white/10 grid place-items-center shrink-0",
    },
  };

  const cardClass = styles[accent]?.card || styles.default.card;
  const iconBoxClass = styles[accent]?.icon || styles.default.icon;

  return (
    <div data-testid={testid} className={`rounded-2xl p-4 md:p-5 flex items-center gap-3.5 transition-all duration-300 hover:-translate-y-0.5 ${cardClass}`}>
      <div className={iconBoxClass}>
        <Icon size={20} />
      </div>
      <div className="min-w-0">
        <div className="text-[10px] uppercase font-bold tracking-widest text-white/50 truncate">{label}</div>
        <div className="text-2xl md:text-3xl font-display font-black text-white mt-0.5">{value}</div>
      </div>
    </div>
  );
}

function MatchCard({ m }) {
  return (
    <Link
      to={`/matches/${m.id}`}
      data-testid={`match-card-${m.id}`}
      className="relative block bg-[#111113]/90 border border-white/10 hover:border-gold-500/40 rounded-2xl p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl group"
    >
      <div className="flex items-center justify-between mb-4 pb-2 border-b border-white/5">
        <div className="flex items-center gap-2">
          <span className="live-dot" />
          <span className="text-[11px] uppercase tracking-widest text-destructive font-black">مباشر الآن</span>
        </div>
        <span className="text-[11px] font-mono text-white/40">{m.game || "Call of Duty"}</span>
      </div>

      <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3">
        {/* الكلان A */}
        <div className="flex flex-col items-center text-center gap-1.5 min-w-0">
          <ClanLogo
            clan={{ logo: m.clan_a?.logo_url || m.clan_a?.logo }}
            className="h-12 w-12 rounded-xl bg-gold-500/10 border border-gold-500/20 grid place-items-center text-gold-500 overflow-hidden shrink-0"
            fallbackIconSize={20}
          />
          <div className="min-w-0 w-full">
            <div className="font-display font-black text-sm text-white truncate">{m.clan_a?.tag}</div>
            <div className="text-[10px] text-white/40 truncate">{m.clan_a?.name}</div>
          </div>
        </div>

        <div className="font-display font-black text-xl text-gold-500 px-2.5 py-1 bg-gold-500/10 rounded-xl border border-gold-500/20">
          VS
        </div>

        {/* الكلان B */}
        <div className="flex flex-col items-center text-center gap-1.5 min-w-0">
          <ClanLogo
            clan={{ logo: m.clan_b?.logo_url || m.clan_b?.logo }}
            className="h-12 w-12 rounded-xl bg-gold-500/10 border border-gold-500/20 grid place-items-center text-gold-500 overflow-hidden shrink-0"
            fallbackIconSize={20}
          />
          <div className="min-w-0 w-full">
            <div className="font-display font-black text-sm text-white truncate">{m.clan_b?.tag}</div>
            <div className="text-[10px] text-white/40 truncate">{m.clan_b?.name}</div>
          </div>
        </div>
      </div>

      <div className="mt-4 pt-2 border-t border-white/5 flex items-center justify-center gap-1 text-xs text-white/40 group-hover:text-gold-400 font-bold transition">
        <span>دخول غرفة المباراة والشات</span>
        <ArrowLeft size={13} className="transition-transform group-hover:-translate-x-1" />
      </div>
    </Link>
  );
}

export default function HomePage() {
  const [live, setLive] = useState([]);
  const [topClans, setTopClans] = useState([]);
  const [rrClans, setRrClans] = useState([]);
  const [rrRanks, setRrRanks] = useState([]);
  const [counts, setCounts] = useState({ live: 0, clans: 0, players: 0 });

  useEffect(() => {
    (async () => {
      const [l, c, stats, rr] = await Promise.all([
        api.get("/matches/live"),
        api.get("/leaderboard/clans"),
        api.get("/stats/counts"),
        api.get("/rank-system"),
      ]);

      setLive(l.data || []);
      setTopClans((c.data || []).slice(0, 5));
      setRrClans((rr.data?.clans || []).slice(0, 10));
      setRrRanks(rr.data?.ranks || []);
      setCounts(stats.data || { live: (l.data || []).length, clans: 0, players: 0 });
    })().catch(() => {});
    const timer = setInterval(() => {
      api.get("/rank-system", {timeout:5000}).then(r => {setRrClans((r.data?.clans || []).slice(0,10));setRrRanks(r.data?.ranks || []);}).catch(() => {});
    }, 15000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="space-y-8" dir="rtl">
      <DrawPanel />
      <HeroCarousel />

      {/* Stats */}
      <section className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        <StatCard icon={Flame} label="مباريات مباشرة" value={counts.live} testid="stat-live" accent="live" />
        <StatCard icon={Shield} label="كلانات نشطة" value={counts.clans} testid="stat-clans" accent="clans" />
        <StatCard icon={Users} label="إجمالي اللاعبين" value={counts.players} testid="stat-players" accent="players" />
        <StatCard icon={Trophy} label="الموسم الحالي" value={new Date().getFullYear()} testid="stat-season" accent="season" />
      </section>

      {/* Live matches + top clans */}
      <section className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="font-display font-black text-xl text-white flex items-center gap-2">
              <Swords size={20} className="text-gold-500" /> المباريات المباشرة الآن
            </h2>
            <Link to="/matches" className="text-xs font-bold text-white/50 hover:text-gold-400 flex items-center gap-1 transition">
              عرض الكافّة <ArrowLeft size={12} />
            </Link>
          </div>

          {live.length === 0 ? (
            <div className="bg-[#111113]/90 border border-white/10 rounded-2xl p-10 text-center text-white/40 text-xs">
              لا توجد مباريات مباشرة جارية حالياً. تابعنا قريباً!
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 gap-4">
              {live.slice(0, 4).map((m) => (
                <MatchCard key={m.id} m={m} />
              ))}
            </div>
          )}
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="font-display font-black text-xl text-white flex items-center gap-2">
              <Trophy size={20} className="text-gold-500" /> تصنيف أبطال الكلانات
            </h2>
            <Link to="/leaderboard" className="text-xs font-bold text-white/50 hover:text-gold-400 flex items-center gap-1 transition">
              الجدول <ArrowLeft size={12} />
            </Link>
          </div>

          <div className="bg-[#111113]/90 border border-white/10 rounded-2xl divide-y divide-white/5 shadow-xl overflow-hidden">
            {topClans.length === 0 && (
              <div className="p-6 text-center text-white/40 text-xs">لا توجد إحصائيات بعد</div>
            )}

            {topClans.map((c, idx) => {
              const isPlusClan = !!(c.is_plus || c.is_clan_plus);

              return (
                <Link
                  key={c.id}
                  to={`/clans/${c.id}`}
                  data-testid={`top-clan-${idx}`}
                  className="flex items-center gap-3 p-3.5 hover:bg-white/5 transition group"
                >
                  <div
                    className={`h-8 w-8 grid place-items-center rounded-xl font-display font-black text-xs shrink-0 ${
                      idx === 0
                        ? "bg-gradient-to-b from-gold-300 via-gold-500 to-gold-700 text-black shadow-[0_0_12px_rgba(255,204,0,0.4)]"
                        : idx === 1
                        ? "bg-gradient-to-b from-gray-200 via-gray-400 to-gray-600 text-black shadow-[0_0_12px_rgba(229,231,235,0.3)]"
                        : idx === 2
                        ? "bg-gradient-to-b from-amber-600 via-amber-700 to-amber-900 text-white shadow-[0_0_12px_rgba(180,83,9,0.3)]"
                        : "bg-white/5 text-white/50"
                    }`}
                  >
                    {idx + 1}
                  </div>

                  <ClanLogo
                    clan={{ logo: c.logo || c.logo_url || c.avatar }}
                    className="h-9 w-9 rounded-lg bg-gold-500/10 border border-gold-500/20 grid place-items-center text-gold-500 overflow-hidden shrink-0"
                    fallbackIconSize={16}
                  />

                  <div className="flex-1 min-w-0">
                    <div className="font-bold truncate text-white text-xs group-hover:text-gold-400 transition flex items-center gap-1">
                      <span className="truncate">{c.name}</span>
                      {isPlusClan && (
                        <Sparkles size={11} className="text-[#d4af37] shrink-0" />
                      )}
                    </div>

                    <div className="text-[10px] text-white/40 font-mono">
                      [{c.tag}]
                    </div>
                  </div>

                  <div className="text-gold-500 font-display font-black text-sm shrink-0">
                    {c.points || 0}{" "}
                    <span className="text-[9px] text-white/40 font-normal">
                      pts
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* RR Ranking */}
      <section className="space-y-3">
        <h2 className="font-display font-black text-xl text-white flex items-center gap-2">
          <Shield size={20} className="text-gold-500" />
          تصنيف RR للكلانات
        </h2>

        <div className="bg-[#111113]/90 border border-white/10 rounded-2xl divide-y divide-white/5 overflow-hidden">
          {rrClans.map((c, idx) => {
            const rank = rrRanks.find((r) => r.name === c.rank_tier);

            return (
              <Link
                key={c.id}
                to={`/clans/${c.id}`}
                className="flex items-center gap-4 p-4 hover:bg-white/5 transition group"
              >
                <span className="w-8 font-black text-gold-400 shrink-0">
                  #{idx + 1}
                </span>

                <div className="h-[72px] w-[72px] rounded-2xl border border-white/10 bg-black/30 grid place-items-center shrink-0 overflow-hidden">
                  {rank?.logo ? (
                    <img
                      src={rank.logo}
                      alt={rank.name || "Rank"}
                      className="h-16 w-16 object-contain drop-shadow-lg"
                    />
                  ) : (
                    <Shield size={28} className="text-white/25" />
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="font-bold text-white group-hover:text-gold-400 transition truncate">
                    {c.name}
                  </div>

                  <div className="text-[11px] text-white/45">
                    {c.rank_tier || "Unranked"}
                  </div>
                </div>

                <span className="font-mono font-black text-gold-400 whitespace-nowrap">
                  {c.rank_points ?? 100} RR
                </span>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
